<template>
    <el-drawer
        title="调整库存"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
                size="medium"
            >
                <el-form-item label="当前库存:">
                    <span slot="label">当前库存: <span class="color-danger">{{formDatas.residueNum}}</span></span>
                </el-form-item>
                <el-form-item prop="type">
                    <span slot="label">调整类型: <small>提交前请先选择是增加还是减少剩余库存</small></span>
                    <el-radio-group v-model="formDatas.type">
                        <el-radio :label="1" border>增加</el-radio>
                        <el-radio v-if="formDatas.residueNum > 0" :label="2" border>减少</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="num" label="调整数量:">
                    <el-input-number 
                        style="width:100%" 
                        v-model="formDatas.num" 
                        :precision="0" 
                        controls-position="right" 
                        :min="1" 
                        :max="formDatas.type == 2 ? formDatas.residueNum : 99999999" 
                        placeholder="请输入调整数量">
                    </el-input-number>
                </el-form-item>
            </el-form>
            
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultData = {
    type:1,
    num: undefined
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas:{
                ...defaultData
            },
            rules:{
                num:[{ required: true, message: "请填写增/减数量",trigger:"change"}]
            },
        }
    },
    methods:{
        close(){
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.formDatas = {
                ...defaultData
            }
        },
        show(data){
            this.formDatas = {
                ...defaultData,
                ...data
            }
            this.drawerShow = true;
        },
        
        //表单提交
        submitForm() {
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    if( this.formDatas.type == 2 && this.formDatas.num > this.formDatas.residueNum){
                        return this.$message.error('减少数量不能大于当前库存');
                    }
                    this.btnLoading = true;    
                    this.$request({
                        url: '/lottery/prize/editStore',
                        params: {
                            ...this.formDatas,
                            num: this.formDatas.type == 2 ? -this.formDatas.num : this.formDatas.num
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit("onUpdate");
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        },
    }
}
</script>